import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const MediosImpContext = createContext();

export const MediosImpContextProvider = ({ children }) => {
  const [counter, setCounter] = useState(0);
  return (
    <MediosImpContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        counter,
        setCounter
      }}>
      {children}
    </MediosImpContext.Provider>
  );
};

MediosImpContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
    .isRequired
};
